import { extendServiceContainer } from '@iotize/tap';
import { DataLogService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    dataLog: DataLogService;
  }
}

export const _TAP_SERVICE_EXTENSION_DATALOG_ = extendServiceContainer(
  'dataLog',
  DataLogService,
);
